var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaceModel2RectElec(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 200",
    width: 100,
    height: 200,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 100,
    height: 200,
    fill: "#75baff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 96,
    height: 196,
    fill: "#D2DAE1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceModel2RectElec);
export default __webpack_public_path__ + "static/media/place_model-2_rect_elec.916e6e96709a6dc7b264118b9fb7ece1.svg";
export { ForwardRef as ReactComponent };